//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { handleTransfer, getAllJobList } from "@/api/managementCenter/jobManage";
export default {
  name: "switchJob",
  props: [],
  data: function data() {
    return {
      show: false,
      loading: false,
      postName: "",
      name: "",
      postId: "",
      list: [],
      form: {
        postId: "",
        postUserId: ""
      },
      rules: {
        postId: [{
          required: true,
          message: "请选择新岗位",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {},
  mounted: function mounted() {},
  methods: {
    getJobListFn: function getJobListFn() {
      var _this = this;

      getAllJobList().then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          _this.list = data.data || [];
        } else {
          _this.$message.warning(data.msg || "获取岗位失败！");
        }
      }).catch(function (err) {});
    },
    // 显示弹框
    dialogShow: function dialogShow(data) {
      var _this2 = this;

      this.show = true;
      this.$nextTick(function () {
        _this2.$refs["ruleForm"].resetFields();

        _this2.postName = data.postName;
        _this2.postId = data.postId;
        _this2.form.postUserId = data.postUserId;
        _this2.name = data.username;
      });
    },
    handleTransferFn: function handleTransferFn() {
      var _this3 = this;

      this.loading = true;
      handleTransfer(this.form).then(function (_ref2) {
        var data = _ref2.data;
        _this3.loading = false;

        if (data.code == 0) {
          _this3.$message.success("调岗成功!");

          _this3.show = false;

          _this3.$emit("saveSuccess");
        } else {
          _this3.$message.warning(data.msg || "调岗失败!");
        }
      }).catch(function (err) {
        _this3.loading = false;

        _this3.$message.error("服务器异常!");
      });
    },
    // 确定提交
    submitForm: function submitForm(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.handleTransferFn();
        } else {
          return false;
        }
      });
    }
  },
  watch: {
    show: function show(value) {
      if (value) {
        this.getJobListFn();
      }
    }
  },
  filters: {}
};